import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {StorefrontAuthenticationWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/storefrontAuthenticationWorkspaceCapability/domain/StorefrontAuthenticationWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type StorefrontAuthenticationWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.storefrontAuthentication> & {
    fixedUdoTemplates: {
        [StorefrontAuthenticationWorkspaceCapabilityUdoTemplateKey.loginCode]: {
            udoAdditionalColumnIds: {
                attempts: Uuid;
                codeHash: Uuid;
                expiresAt: Uuid;
                identifier: Uuid;
                loginMethod: Uuid;
                ottokartStorefrontCustomerId: Uuid;
                status: Uuid;
            };
        };
        [StorefrontAuthenticationWorkspaceCapabilityUdoTemplateKey.authToken]: {
            udoAdditionalColumnIds: {
                expiresAt: Uuid;
                ipAddress: Uuid;
                lastUsedAt: Uuid;
                ottokartStorefrontCustomerId: Uuid;
                status: Uuid;
                tokenHash: Uuid;
                tokenType: Uuid;
                userAgent: Uuid;
            };
        };
    };
};

export const storefrontAuthenticationWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [StorefrontAuthenticationWorkspaceCapabilityUdoTemplateKey.loginCode]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                status: uuidZodValidator,
                ottokartStorefrontCustomerId: uuidZodValidator,
                loginMethod: uuidZodValidator,
                identifier: uuidZodValidator,
                codeHash: uuidZodValidator,
                expiresAt: uuidZodValidator,
                attempts: uuidZodValidator,
            }),
        }),
        [StorefrontAuthenticationWorkspaceCapabilityUdoTemplateKey.authToken]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                status: uuidZodValidator,
                ottokartStorefrontCustomerId: uuidZodValidator,
                tokenHash: uuidZodValidator,
                tokenType: uuidZodValidator,
                expiresAt: uuidZodValidator,
                lastUsedAt: uuidZodValidator,
                ipAddress: uuidZodValidator,
                userAgent: uuidZodValidator,
            }),
        }),
    }),
}) satisfies zod.ZodType<StorefrontAuthenticationWorkspaceCapabilityUdoBindings>;
